<div class="page-title-area">
    <img src="assets/images/finance-b2.png" alt="Page Background" class="page-bg" style="width: 100%; height: 100%;">
    <div class="container">
        <div class="section-title program-title" style="text-align: left;">
            <h2 style="color: #fff !important; font-weight: 500;">Apple Finance & Flexible Payment Plans</h2>
            <!-- <h4 style="color: #fff !important; font-weight: 200;">Exclusive Employee Offers for Your Organization</h4> -->
        </div>
    </div>
</div>
  
  <section class="services-details-area ptb-100">
      <div class="container">
          <div class="scrives-item-2 mt-4 ">
              <div class="row align-items-center">
                  <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                      <div class="services-img mb-qc ios-content">
                          <div class="circular-layout">
                              <div class="image-container">
                                <img src="assets/images/finance-services1.jpg" alt="image" class="image-container-img"/>
                              </div>
                            </div>
                      </div>
                  </div>
  
                  <div class="col-lg-6">
                    <p>Don’t let upfront costs hold back innovation.</p>
                    <p>With Superior Digital’s flexible financing and leasing options, you can equip your business with the latest Apple technology—on your terms.</p>
                    <p>We offer custom payment plans designed to match your budget and business cycles.</p>
                    <p>Whether you’re looking to scale or refresh your devices, our financial solutions give you freedom and flexibility.</p>
                    <p>Empower your team with the best tools—without compromising your cash flow.</p>
                </div>
              </div>
          </div>
  
          <!-- <div class="scrives-item-2 mt-4 ">
              <div class="row align-items-center">
                  <div class="col-lg-12">
                      <p>Connect with us to explore financing options that work for your business!</p>
                  </div>
              </div>
          </div> -->
      </div>
  </section>
  
  <div class="container mb-4">
      <div class="d-flex justify-content-end">
          <button class="btn back-btn" (click)="navigateToHome()">
              <i class="fas fa-arrow-left me-2"></i> Back to Home
          </button>
      </div>
  </div>
